module.exports = __webpack_public_path__ + "static/media/MarksExcel.c9df5296.xlsx";